export interface TBuildRowCountInput {
    total: number;
    totalUnfiltered: number | null | undefined;
    hasActiveFilters: boolean;
    /** `total` is a lower bound (the server stopped counting at a cap). */
    totalCapped?: boolean;
    /** `totalUnfiltered` is a lower bound. */
    totalUnfilteredCapped?: boolean;
}

export type TRowCount = {
    filtered: number;
    total: number;
    isFiltered: boolean;
    filteredIsLowerBound?: boolean;
    totalIsLowerBound?: boolean;
};

export function buildRowCount({
    total,
    totalUnfiltered,
    hasActiveFilters,
    totalCapped = false,
    totalUnfilteredCapped = false,
}: TBuildRowCountInput): TRowCount {
    const grand = totalUnfiltered ?? total;
    const grandCapped = totalUnfiltered == null ? totalCapped : totalUnfilteredCapped;
    const isFiltered = hasActiveFilters || (totalUnfiltered != null && total !== totalUnfiltered);
    const result: TRowCount = { filtered: total, total: grand, isFiltered };
    // Only set when true, so uncapped callers get the same shape as before.
    if (totalCapped) result.filteredIsLowerBound = true;
    if (grandCapped) result.totalIsLowerBound = true;
    return result;
}
